import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FeatureFlags, HealthState } from '@handover/shared-types';

const initialState: HealthState = {
  features: {
    authLogin: true,
    authChangeRole: true,
    authBlockUser: false,
    handoverDocDelete: true,
    handoverAddComment: true,
    fileUpload: true,
    ai: false, // Default to false until confirmed
  },
  isLoading: false,
  error: null,
  lastChecked: null,
};

const healthSlice = createSlice({
  name: 'health',
  initialState,
  reducers: {
    setFeatures: (state, action: PayloadAction<FeatureFlags>) => {
      state.features = action.payload;
      state.lastChecked = new Date().toISOString();
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
  },
});

export const { setFeatures, setLoading, setError } = healthSlice.actions;
export default healthSlice.reducer;
